'use strict'

const MAP_ELEVATION_SETTINGS_TEMPLATE_SELECTOR = '[data-tpl-map-elevation-settings]'

const cloneMapElevationSettingsTemplate = function () {
  if (typeof document === 'undefined') return null
  const template = document.querySelector(MAP_ELEVATION_SETTINGS_TEMPLATE_SELECTOR)
  if (!(template instanceof HTMLTemplateElement)) return null
  const root = template.content.firstElementChild
  return root ? root.cloneNode(true) : null
}

const assignMapElevationFieldId = function (inputEl, labelEl, suffix) {
  if (!(inputEl instanceof HTMLElement) || !(labelEl instanceof HTMLElement)) return
  const nextId = 'map-elevation-settings-' + String(suffix || 'field') + '-' + String(Date.now()) + '-' + String(Math.round(Math.random() * 10000))
  inputEl.setAttribute('id', nextId)
  labelEl.setAttribute('for', nextId)
}

const populateMapElevationSelect = function (selectEl, providers, currentValue, fnGetDemProviderLabel) {
  if (!(selectEl instanceof HTMLSelectElement)) return
  while (selectEl.firstChild) {
    selectEl.removeChild(selectEl.firstChild)
  }
  ;(Array.isArray(providers) ? providers : []).forEach(function (providerKey) {
    const optionEl = document.createElement('option')
    optionEl.value = String(providerKey || '')
    optionEl.textContent = fnGetDemProviderLabel(providerKey)
    optionEl.selected = (String(providerKey || '').trim() === String(currentValue || '').trim())
    selectEl.appendChild(optionEl)
  })
}

const openMapCursorElevationSettingsModal = function () {
  const Swal = window.Swal
  const areaSwal = window.PORTAL_AREA_SWAL || Swal
  const baseSwal = window.PORTAL_BASE_SWAL || areaSwal
  const fnGetMapCursorElevationProvider = window.PORTAL_GET_MAP_CURSOR_ELEVATION_PROVIDER || function () { return 'gDEM' }
  const fnGetMapCursorElevationFallbackProvider = window.PORTAL_GET_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER || function () { return fnGetMapCursorElevationProvider() }
  const fnGetMapCursorElevationRemoteEnabled = window.PORTAL_GET_MAP_CURSOR_ELEVATION_REMOTE_ENABLED || function () { return false }
  const fnGetMapCursorElevationLocalEnabled = window.PORTAL_GET_MAP_CURSOR_ELEVATION_LOCAL_ENABLED || function () { return true }
  const fnGetMapCursorElevationGridSnapEnabled = window.PORTAL_GET_MAP_CURSOR_ELEVATION_GRID_SNAP_ENABLED || function () { return true }
  const fnBuildMapCursorElevationTryOrder = window.PORTAL_BUILD_MAP_CURSOR_ELEVATION_TRY_ORDER || function () { return ['gDEM'] }
  const fnGetDemProviderLabel = window.PORTAL_GET_DEM_PROVIDER_LABEL || function (providerKey) { return String(providerKey || '') }
  const fnT = window.PORTAL_T || function (key, fallback) { return String(fallback || key || '') }
  const fnIsDemProviderEnabled = window.PORTAL_IS_DEM_PROVIDER_ENABLED || function () { return true }
  const fnSetMapCursorElevationProvider = window.PORTAL_SET_MAP_CURSOR_ELEVATION_PROVIDER || function () {}
  const fnSetMapCursorElevationFallbackProvider = window.PORTAL_SET_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER || function () {}
  const fnSetMapCursorElevationRemoteEnabled = window.PORTAL_SET_MAP_CURSOR_ELEVATION_REMOTE_ENABLED || function () {}
  const fnSetMapCursorElevationLocalEnabled = window.PORTAL_SET_MAP_CURSOR_ELEVATION_LOCAL_ENABLED || function () {}
  const fnSetMapCursorElevationGridSnapEnabled = window.PORTAL_SET_MAP_CURSOR_ELEVATION_GRID_SNAP_ENABLED || function () {}
  const fnScheduleRoute3dSharedSync = window.PORTAL_SCHEDULE_ROUTE3D_SHARED_SYNC || function () {}
  const templateRoot = cloneMapElevationSettingsTemplate()

  if (!(templateRoot instanceof HTMLElement)) {
    if (Swal && typeof Swal.fire === 'function') {
      void Swal.fire(fnT('map_elevation.settings_template_missing'))
    }
    return
  }

  const fnIsProviderAvailable = function (providerKey) {
    const key = String(providerKey || '').trim()
    if (!key) return false
    if (key === 'localDEM') {
      const localState = (typeof window !== 'undefined') ? window.PORTAL_LOCAL_TERRAIN_STATE : null
      return !!(
        localState &&
        localState.active === true &&
        (
          typeof localState.sampleElevation === 'function' ||
          typeof localState.sampleElevationAsync === 'function' ||
          typeof localState.sampleElevations === 'function'
        )
      )
    }
    return fnIsDemProviderEnabled(key)
  }

  const currentProvider = String(fnGetMapCursorElevationProvider() || '').trim() || 'gDEM'
  const providers = fnBuildMapCursorElevationTryOrder(currentProvider)
  const fallbackProviders = providers.filter(function (providerKey) {
    return String(providerKey || '').trim() !== 'localDEM'
  })
  const fallbackProviderList = fallbackProviders.length ? fallbackProviders : providers
  const currentFallbackRaw = String(fnGetMapCursorElevationFallbackProvider() || '').trim()
  const currentFallback = fallbackProviderList.includes(currentFallbackRaw)
    ? currentFallbackRaw
    : (fallbackProviderList[0] || currentProvider)
  const initialProvider = currentProvider
  const initialFallbackProvider = currentFallback
  const initialRemoteEnabled = (fnGetMapCursorElevationRemoteEnabled() === true)
  const initialLocalEnabled = (fnGetMapCursorElevationLocalEnabled() !== false)
  const initialGridSnapEnabled = (fnGetMapCursorElevationGridSnapEnabled() !== false)

  const remoteToggleEl = templateRoot.querySelector('[data-map-elevation-remote-toggle]')
  const remoteLabelEl = templateRoot.querySelector('[data-map-elevation-remote-label]')
  const localToggleEl = templateRoot.querySelector('[data-map-elevation-local-toggle]')
  const localLabelEl = templateRoot.querySelector('[data-map-elevation-local-label]')
  const gridSnapToggleEl = templateRoot.querySelector('[data-map-elevation-grid-snap-toggle]')
  const gridSnapLabelEl = templateRoot.querySelector('[data-map-elevation-grid-snap-label]')
  const gridSnapHelpEl = templateRoot.querySelector('[data-map-elevation-grid-snap-help]')
  const providerLabelEl = templateRoot.querySelector('[data-map-elevation-provider-label]')
  const providerSelectEl = templateRoot.querySelector('[data-map-elevation-provider-select]')
  const fallbackLabelEl = templateRoot.querySelector('[data-map-elevation-fallback-label]')
  const fallbackSelectEl = templateRoot.querySelector('[data-map-elevation-fallback-provider-select]')
  const helpEl = templateRoot.querySelector('[data-map-elevation-help]')
  const fallbackHelpEl = templateRoot.querySelector('[data-map-elevation-fallback-help]')

  if (remoteLabelEl) remoteLabelEl.textContent = fnT('map_elevation.settings_remote_toggle_label')
  if (localLabelEl) localLabelEl.textContent = fnT('map_elevation.settings_local_toggle_label')
  if (gridSnapLabelEl) gridSnapLabelEl.textContent = fnT('map_elevation.settings_grid_snap_toggle_label')
  if (providerLabelEl) providerLabelEl.textContent = fnT('map_elevation.settings_provider_label')
  if (fallbackLabelEl) fallbackLabelEl.textContent = fnT('map_elevation.settings_fallback_provider_label')
  if (helpEl) helpEl.textContent = fnT('map_elevation.settings_help')
  if (fallbackHelpEl) fallbackHelpEl.textContent = fnT('map_elevation.settings_fallback_help')
  if (gridSnapHelpEl) gridSnapHelpEl.textContent = fnT('map_elevation.settings_grid_snap_help')

  assignMapElevationFieldId(remoteToggleEl, remoteLabelEl, 'remote')
  assignMapElevationFieldId(localToggleEl, localLabelEl, 'local')
  assignMapElevationFieldId(gridSnapToggleEl, gridSnapLabelEl, 'grid-snap')
  assignMapElevationFieldId(providerSelectEl, providerLabelEl, 'provider')
  assignMapElevationFieldId(fallbackSelectEl, fallbackLabelEl, 'fallback')

  populateMapElevationSelect(providerSelectEl, providers, currentProvider, fnGetDemProviderLabel)
  populateMapElevationSelect(fallbackSelectEl, fallbackProviderList, currentFallback, fnGetDemProviderLabel)

  areaSwal.fire({
    title: fnT('map_elevation.settings_title'),
    html: templateRoot.outerHTML,
    showCancelButton: true,
    confirmButtonText: fnT('common.save'),
    cancelButtonText: fnT('common.cancel'),
    didOpen: function (popupEl) {
      const popupRemoteToggleEl = popupEl ? popupEl.querySelector('[data-map-elevation-remote-toggle]') : null
      const popupLocalToggleEl = popupEl ? popupEl.querySelector('[data-map-elevation-local-toggle]') : null
      const popupGridSnapToggleEl = popupEl ? popupEl.querySelector('[data-map-elevation-grid-snap-toggle]') : null
      const popupProviderSelectEl = popupEl ? popupEl.querySelector('[data-map-elevation-provider-select]') : null
      const popupFallbackSelectEl = popupEl ? popupEl.querySelector('[data-map-elevation-fallback-provider-select]') : null
      if (popupRemoteToggleEl instanceof HTMLInputElement) popupRemoteToggleEl.checked = initialRemoteEnabled
      if (popupLocalToggleEl instanceof HTMLInputElement) popupLocalToggleEl.checked = initialLocalEnabled
      if (popupGridSnapToggleEl instanceof HTMLInputElement) popupGridSnapToggleEl.checked = initialGridSnapEnabled
      if (popupProviderSelectEl instanceof HTMLSelectElement) popupProviderSelectEl.value = currentProvider
      if (popupFallbackSelectEl instanceof HTMLSelectElement) popupFallbackSelectEl.value = currentFallback
      const fnApplyLiveSelection = function () {
        const remoteEnabled = !!(popupRemoteToggleEl instanceof HTMLInputElement && popupRemoteToggleEl.checked)
        const localEnabled = !(popupLocalToggleEl instanceof HTMLInputElement) || popupLocalToggleEl.checked
        const gridSnapEnabled = !(popupGridSnapToggleEl instanceof HTMLInputElement) || popupGridSnapToggleEl.checked
        const providerKey = String(popupProviderSelectEl instanceof HTMLSelectElement ? popupProviderSelectEl.value : '').trim()
        const fallbackProviderKey = String(popupFallbackSelectEl instanceof HTMLSelectElement ? popupFallbackSelectEl.value : '').trim()
        fnSetMapCursorElevationRemoteEnabled(remoteEnabled, { persist: false })
        fnSetMapCursorElevationLocalEnabled(localEnabled, { persist: false })
        fnSetMapCursorElevationGridSnapEnabled(gridSnapEnabled, { persist: false })
        if (providerKey && fnIsProviderAvailable(providerKey)) {
          fnSetMapCursorElevationProvider(providerKey, {
            showToast: false,
            fallbackProvider: fallbackProviderKey,
            persist: false
          })
        }
        if (fallbackProviderKey && fnIsProviderAvailable(fallbackProviderKey)) {
          fnSetMapCursorElevationFallbackProvider(fallbackProviderKey, { persist: false })
        }
        fnScheduleRoute3dSharedSync()
      }
      if (popupRemoteToggleEl instanceof HTMLInputElement) popupRemoteToggleEl.addEventListener('change', fnApplyLiveSelection)
      if (popupLocalToggleEl instanceof HTMLInputElement) popupLocalToggleEl.addEventListener('change', fnApplyLiveSelection)
      if (popupGridSnapToggleEl instanceof HTMLInputElement) popupGridSnapToggleEl.addEventListener('change', fnApplyLiveSelection)
      if (popupProviderSelectEl instanceof HTMLSelectElement) popupProviderSelectEl.addEventListener('change', fnApplyLiveSelection)
      if (popupFallbackSelectEl instanceof HTMLSelectElement) popupFallbackSelectEl.addEventListener('change', fnApplyLiveSelection)
    },
    preConfirm: function () {
      const popup = (areaSwal && typeof areaSwal.getPopup === 'function')
        ? areaSwal.getPopup()
        : (Swal && typeof Swal.getPopup === 'function' ? Swal.getPopup() : null)
      const providerSelect = popup ? popup.querySelector('[data-map-elevation-provider-select]') : null
      const fallbackSelect = popup ? popup.querySelector('[data-map-elevation-fallback-provider-select]') : null
      const remoteToggle = popup ? popup.querySelector('[data-map-elevation-remote-toggle]') : null
      const localToggle = popup ? popup.querySelector('[data-map-elevation-local-toggle]') : null
      const gridSnapToggle = popup ? popup.querySelector('[data-map-elevation-grid-snap-toggle]') : null
      const providerKey = String(providerSelect instanceof HTMLSelectElement ? providerSelect.value : '').trim()
      const fallbackProviderKey = String(fallbackSelect instanceof HTMLSelectElement ? fallbackSelect.value : '').trim()
      if (!providerKey || !fnIsProviderAvailable(providerKey)) {
        Swal.showValidationMessage(fnT('map_elevation.settings_provider_required'))
        return false
      }
      if (!fallbackProviderKey || !fnIsProviderAvailable(fallbackProviderKey)) {
        Swal.showValidationMessage(fnT('map_elevation.settings_fallback_provider_required'))
        return false
      }
      return {
        providerKey: providerKey,
        fallbackProviderKey: fallbackProviderKey,
        remoteEnabled: (remoteToggle instanceof HTMLInputElement) && remoteToggle.checked,
        localEnabled: !(localToggle instanceof HTMLInputElement) || localToggle.checked,
        gridSnapEnabled: !(gridSnapToggle instanceof HTMLInputElement) || gridSnapToggle.checked
      }
    }
  }).then(function (result) {
    if (!result || !result.isConfirmed || !result.value) {
      fnSetMapCursorElevationRemoteEnabled(initialRemoteEnabled, { persist: false })
      fnSetMapCursorElevationLocalEnabled(initialLocalEnabled, { persist: false })
      fnSetMapCursorElevationGridSnapEnabled(initialGridSnapEnabled, { persist: false })
      fnSetMapCursorElevationProvider(initialProvider, {
        showToast: false,
        fallbackProvider: initialFallbackProvider,
        persist: false
      })
      fnSetMapCursorElevationFallbackProvider(initialFallbackProvider, { persist: false })
      fnScheduleRoute3dSharedSync()
      return
    }
    const providerKey = String(result.value.providerKey || '').trim()
    const fallbackProviderKey = String(result.value.fallbackProviderKey || '').trim()
    const remoteEnabled = (result.value.remoteEnabled === true)
    const localEnabled = (result.value.localEnabled !== false)
    const gridSnapEnabled = (result.value.gridSnapEnabled !== false)
    if (!providerKey || !fallbackProviderKey) return
    fnSetMapCursorElevationRemoteEnabled(remoteEnabled, { persist: false })
    fnSetMapCursorElevationLocalEnabled(localEnabled, { persist: true })
    fnSetMapCursorElevationGridSnapEnabled(gridSnapEnabled, { persist: true })
    fnSetMapCursorElevationProvider(providerKey, {
      showToast: false,
      fallbackProvider: fallbackProviderKey,
      persist: true
    })
    fnSetMapCursorElevationFallbackProvider(fallbackProviderKey, { persist: false })
    fnScheduleRoute3dSharedSync()
    baseSwal.fire({
      toast: true,
      position: 'bottom-end',
      icon: 'success',
      title: fnT('map_elevation.settings_saved'),
      text: fnGetDemProviderLabel(providerKey) + ' / ' + fnGetDemProviderLabel(fallbackProviderKey),
      timerProgressBar: true,
      showConfirmButton: false
    })
  })
}

export {
  openMapCursorElevationSettingsModal
}
